import { PrivateInformationBirthdateType } from 'src/features/persons/PersonPrivateInformation/components/EditPrivateInformationForm/hooks';
import { BirthdateInputUnionType } from '../common';
import {
  focusNextField,
  getNewValue,
  getShouldFocusNextField,
} from './helpers';

type HandleChangeArgsType = {
  inputValue: string;
  previousValue: PrivateInformationBirthdateType;
  setValue: (value: PrivateInformationBirthdateType) => void;
  inputType: BirthdateInputUnionType;
  monthInputRef: React.RefObject<HTMLInputElement | null>;
  yearInputRef: React.RefObject<HTMLInputElement | null>;
};

export const handleChange = ({
  inputValue,
  previousValue,
  setValue,
  inputType,
  monthInputRef,
  yearInputRef,
}: HandleChangeArgsType): void => {
  setValue(getNewValue({ previousValue, inputValue, inputType }));

  const shouldFocusNextField = getShouldFocusNextField({
    inputValue,
    inputType,
  });

  if (!shouldFocusNextField) return;

  focusNextField({ inputType, monthInputRef, yearInputRef });
};
